import { Col, Image, Input, Row, Table, Flex, Progress, Switch, Form, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import qs from 'qs';
import useSwr from 'swr';
import { Link, useSearchParams } from "react-router-dom";
import PlantSpeciesService from '../../API/PlantSpeciesService';
import { PictureOutlined, TagsOutlined } from '@ant-design/icons';
import { zonedTimeToUtc } from 'date-fns-tz';
import AnnotationStatsBar from './AnnotationStatsBar';
import { getQueryFromPath } from '../../utils/query';

import Root from './root';

const { Search } = Input;

const PreviewImage = ({ item }) => {
    return (
        <Image
            src={item.default_photo}
            fallback="data:image/png;base64,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"
            width={25}
            height={25}
            placeholder={true}
        />
    )
}

const NameColumn = ({ item }) => {
    return (
        <div>
            {item.wikipedia_url ?
                <a href={item.wikipedia_url} target="_blank" rel="noreferrer">{item.name}</a>
                :
                item.name
            }
        </div>
    )
}

const AnnotationProgressColumn = ({ item }) => {
    const percent = item.annotated_count ? Math.round((item.annotated_count / item.total_count) * 100, 2) : 0;

    return (
        <div>
            {item.annotated_count &&
                <Progress size="small" steps={3} percent={percent} />
            }
        </div>
    )
}

const columns = [
    {
        title: 'img',
        dataIndex: 'default_photo',
        key: 'default_photo',
        render: (text, record) => <PreviewImage item={record} />,
        width: '60px',
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => <NameColumn item={record} />
    },
    {
        title: 'Species',
        dataIndex: 'species',
        key: 'species',
    },
    {
        title: '#Rank',
        dataIndex: 'rank',
        key: 'Rank',
        sorter: true,
    },
    {
        title: 'Progress',
        dataIndex: 'annotated_count',
        key: 'annotated_count',
        render: (text, record) => <AnnotationProgressColumn item={record} />
    },
    {
        title: 'count',
        dataIndex: 'index_cnt',
        key: 'index_cnt',
        sorter: true
    },
    {
        title: 'Updated at',
        dataIndex: 'updated_at',
        key: 'updated_at',
        sorter: true,
        render: (text, record) => record?.updated_at && zonedTimeToUtc(record.updated_at).toLocaleString(),
    },
    {
        title: 'Labels',
        dataIndex: 'annotation_stats',
        key: 'annotation_stats',
        width: '40%',
        render: (text, record) => <AnnotationStatsBar annotation_stats={record?.annotation_stats} />,
    },
    {
        title: 'Action',
        key: 'action',
        width: '15%',
        render: (text, record) => (
            <Space size="middle">
                <Link target="_blank" to={`/plant-species/${record.species}/images/all`}><PictureOutlined /> Images</Link>
                <Link target="_blank" to={`/plant-species/${record.species}/annotate`}><TagsOutlined /> Annotate</Link>
            </Space>
        ),
    },
]

export async function fetcher(url) {
    const query = getQueryFromPath(url);

    const { data } = await PlantSpeciesService.getAll(
        query.limit || 10,
        query.offset || 0,
        query.search || undefined,
        query.showAnnotated || undefined,
        query.sorter || undefined,
        query.order || undefined
    );

    return data
}


const SpeciesTable = () => {
    let [searchParams, setSearchParams] = useSearchParams();

    const patchSearchParams = (newParams = {}) => {
        setSearchParams((searchParams) => {
            const prevParams = {};
            searchParams.forEach((value, key) => {
                prevParams[key] = value;
            });

            for (const key in newParams) {
                if (newParams[key] === undefined) {
                    delete newParams[key];
                    delete prevParams[key];
                }
            }

            return { ...prevParams, ...newParams };
        });
    };

    const limit = searchParams.get('limit') || 10;
    const offset = searchParams.get('offset') || 0;
    const sorter = searchParams.get('sorter') || undefined;
    const order = searchParams.get('order') || undefined;
    const search = searchParams.get('search') || undefined;
    const showAnnotated = searchParams.get('showAnnotated') || undefined;

    const [searchVal] = useState(search);

    const params = qs.stringify({
        limit: limit,
        offset: offset,
        sorter: sorter,
        order: order,
        search: search,
        showAnnotated: showAnnotated,
    }, {
        addQueryPrefix: true,
    });

    const { data, error, loading } = useSwr(`/api/plant-species${params}`, fetcher, {
        revalidateOnReconnect: false,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        keepPreviousData: true,
    });

    const paginationParams = {
        current: (data?.offset / data?.limit + 1) || 1,
        pageSize: 10,
        total: data?.count,
    }

    const sortParams = {
        field: sorter,
        order: order
    }

    const handleTableChange = (pagination, filters, sorter) => {
        console.log('pagination', pagination)
        console.log('sorter', sorter)
        console.log('filters', filters)
        patchSearchParams({
            limit: pagination.pageSize,
            offset: (pagination.current - 1) * pagination.pageSize,
            sorter: sorter.field,
            order: sorter.order
        });
    };
    // TODO: Refactor
    const handleSearch = (val) => {
        patchSearchParams({
            search: val || undefined,
            offset: 0,
            sorter: undefined,
            order: undefined
        });
    }
    // TODO: Refactor
    const handleShowAnnotated = (val) => {
        patchSearchParams({
            showAnnotated: val || undefined,
            offset: 0,
            sorter: undefined,
            order: undefined
        });
    }

    return (
        <Root>
            <Row justify="left">
                <Col span={12} >
                    <div style={{ padding: "0 0 20px 0" }}>
                        <Search
                            value={searchVal}
                            placeholder="input search text"
                            allowClear
                            enterButton="Search"
                            size="large"
                            onSearch={handleSearch}
                        />
                    </div>
                    <Flex gap={10} align='center'>
                        <Form.Item label="Only annotated">
                            <Switch checked={showAnnotated} onChange={handleShowAnnotated} />
                        </Form.Item>
                    </Flex>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        rowKey={(record) => `key-${record.species}`}
                        dataSource={data?.results}
                        columns={columns}
                        loading={loading}
                        pagination={paginationParams}
                        sorter={sortParams}
                        onChange={handleTableChange}
                    />
                </Col>
            </Row>
        </Root>

    );
};

const PlantSpecies = () => {
    return <SpeciesTable />
};

export default PlantSpecies;